import { render, staticRenderFns } from "./BodyPartInfo.vue?vue&type=template&id=231d60f2&"
import script from "./BodyPartInfo.vue?vue&type=script&lang=js&"
export * from "./BodyPartInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports